import { Component, OnInit, OnDestroy } from '@angular/core';
import { Alert, AlertConfiguration } from '../../alert';
import { ToastrService } from 'ngx-toastr';
import { AlertManagementService } from '../../alert-management.service';
import { DataManagementService } from '../../../data-management/data-management.service';
import { Subscription } from 'rxjs/Rx';
import { AlertManagementServiceUtils } from '../../alert-management-utils.service';

@Component({
  selector: 'app-tire-settings',
  templateUrl: './tire-settings.component.html',
  styleUrls: ['./tire-settings.component.css']
})
export class TireSettingsComponent implements OnInit, OnDestroy {
  /*** loader */
  public loader = false;
  public enableGlobalConfig = false;
  public enableGlobalConfigToAllVehicules = false;

  alert: Alert = new Alert();
  getVehiculeWasSelectedSubscription: Subscription;
  tireAlertConfiguration: AlertConfiguration = new AlertConfiguration();
  constructor(
    private toastr: ToastrService,
    public alertManagementService: AlertManagementService,
    private dataManagementService: DataManagementService,
    private alertManagementServiceUtils: AlertManagementServiceUtils
  ) {
    this.alertManagementService.initDays();
  }

  ngOnInit() {
    if (this.dataManagementService.selectedVehicule != null) {
      this.loadAlertConfigOfDevice(
        this.dataManagementService.selectedVehicule.idDevice
      );
    }
    this.getVehiculeWasSelectedSubscription = this.dataManagementService
      .getVehiculeWasSelected()
      .subscribe(vehicule => {
        this.loadAlertConfigOfDevice(
          this.dataManagementService.selectedVehicule.idDevice
        );
      });
  }

  ngOnDestroy() {
    if (this.getVehiculeWasSelectedSubscription) {
      this.getVehiculeWasSelectedSubscription.unsubscribe();
    }
  }

  loadAlertConfigOfDevice(device: number) {
    this.loader = true;
    this.alertManagementService
      .getAlertByNameAndDeviceId('TIRE', device)
      .subscribe(
        alert => {
          this.alert = alert;
          this.tireAlertConfiguration = this.alert.alertConfigurations.filter(
            alertConfiguration => alertConfiguration.type === 'Max_km'
          )
            ? this.alert.alertConfigurations.filter(
              alertConfiguration => alertConfiguration.type === 'Max_km'
            )[0]
            : this.tireAlertConfiguration;
          if (this.tireAlertConfiguration == null) {
            this.tireAlertConfiguration = this.alertManagementServiceUtils.initializeAlertConfiguration(
              'Max_km'
            );
          }
          this.loader = false;
          this.toastr.success('Configuration chargée', 'info !', {
            timeOut: 1000
          });
        },
        () => {
          this.loader = false;
          this.toastr.error('Configuration non chargée', 'info !', {
            timeOut: 1000
          });
        }
      );
  }
  save() {
    this.loader = true;
    this.alert.enableGlobalConfig = this.enableGlobalConfig;
    this.alertManagementService.updateAlert(this.alert).subscribe(
      alert => {
        this.alert = alert;
        this.loader = false;
        this.toastr.success('Configuration enregistrer', 'info !');
      },
      error => {
        this.loader = false;
        this.toastr.error('Configuration non enregistrée', 'info !');
      }
    );
  }
  emailSettings(emailsSettings: { emailMode: boolean; emails: string; enableGlobalConfig: boolean, enableGlobalConfigToAllVehicules: boolean }) {
    this.alert.emailMode = emailsSettings.emailMode;
    this.alert.emails = emailsSettings.emails;
    this.enableGlobalConfig = emailsSettings.enableGlobalConfig;
    this.enableGlobalConfigToAllVehicules = emailsSettings.enableGlobalConfigToAllVehicules;
    if (emailsSettings.enableGlobalConfig || emailsSettings.enableGlobalConfigToAllVehicules) {
      this.updateEmails();
    }
  }
  updateEmails() {
    let id = 0;
    if (this.enableGlobalConfig || this.enableGlobalConfigToAllVehicules) {
      id = this.alert.deviceId;
    } else {
      id = this.alert.id;
    }
    this.alertManagementService.setEmailToAllAlert(this.alert.emails, id, this.enableGlobalConfig, this.enableGlobalConfigToAllVehicules)
      .subscribe(res => {
        if (res) {
          this.toastr.success('emails bien copiés ');
        } else {
          this.toastr.warning('Veuillez reverifier');
        }
      }
      )
  }
}
